import React from 'react';
import './App.css';
import Home from './Home';
import LarasHome from './LarasHome';

const RootComponent = process.env.REACT_APP_COMPONENT === 'latin' ? LarasHome : Home;

function App() {
  return (
    <div className="container">
      <RootComponent />
    </div>
  );
}

export default App;
